import { formatCurrency } from "../support-extra/utils/utils";

const BUTTERFLY_SETUP = [13, 10, 2, 0, 3, 0];
const SQUARE_SETUP = [13, 10, 2, 0, 4, 0];

const getCommands = (type, code, description, pvp, discountedPvp, quantity) => {
  const formattedPvp = formatCurrency(pvp).replace("€", "ÿ");
  const formattedDiscountedPvp = formatCurrency(discountedPvp).replace(
    "€",
    "ÿ",
  );

  switch (type) {
    case "type4":
    case "type5":
      return {
        setup: BUTTERFLY_SETUP,
        commands: [
          "^W55",
          "^P1",
          `^C${quantity}`,
          "^R0",
          "^O0",
          "^D0",
          "^R0",
          "^Q13,3",
          "~R200",
          "~Q0",
          "^E15",
          "^L",
          `BN,300,20,2,4,39,0,0,${code}`,
          `AB,320,55,1,1,0,0,${code}`,
          `AB,10,23,1,1,0,0,${description}`,
          `AB,10,43,1,1,0,0,${formattedPvp}`,
          "E",
        ],
      };
    case "type6":
      return {
        setup: BUTTERFLY_SETUP,
        commands: [
          "^W55",
          "^P1",
          `^C${quantity}`,
          "^R0",
          "^O0",
          "^D0",
          "^R0",
          "^Q13,3",
          "~R200",
          "~Q0",
          "^E15",
          "^L",
          `BN,300,20,2,4,39,0,0,${code}`,
          `AB,320,55,1,1,0,0,${code}`,
          `AB,10,33,1,1,0,0,PVP ${formattedPvp}`,
          `AB,10,58,1,1,0,0,PVP ${formattedDiscountedPvp}`,
          `AB,53,22,1,1,0,0,${"_".repeat(formattedPvp.length)}`,
          "E",
        ],
      };
    default:
      return null;
  }
};

export const printCode = async (
  type,
  code,
  description,
  pvp,
  discountedPvp,
  quantity,
) => {
  const payload = getCommands(
    type,
    code,
    description,
    pvp,
    discountedPvp,
    quantity,
  );
  if (!payload) return;
  try {
    const response = await fetch("http://localhost:9001/print", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) return `Error del servidor: ${response.status}`;
  } catch (err) {
    // console.log("ERROR GoDEX: ", err.message);
    return err?.message || "Error desconocido";
  }
};
